import { memo } from "react";
import * as Styled from "./style";
export const Skeleton = memo(() => <Styled.Skeleton />);
Skeleton.displayName = "Skeleton";
